export const RICH_EDITOR_FONTS = [
  { value: 'yahei', family: '"Microsoft YaHei", "PingFang SC", sans-serif' },
  { value: 'simhei', family: 'SimHei, "Heiti SC", sans-serif' },
  { value: 'simsun', family: 'SimSun, "Songti SC", serif' },
  { value: 'kaiti', family: 'KaiTi, "Kaiti SC", serif' },
  { value: 'fangsong', family: 'FangSong, "STFangsong", serif' },
  { value: 'pingfang', family: '"PingFang SC", "Microsoft YaHei", sans-serif' },
  { value: 'arial', family: 'Arial, Helvetica, sans-serif' },
  { value: 'times', family: '"Times New Roman", Times, serif' },
  { value: 'georgia', family: 'Georgia, serif' },
  { value: 'tahoma', family: 'Tahoma, Geneva, sans-serif' },
  { value: 'verdana', family: 'Verdana, Geneva, sans-serif' }
]

export function buildRichEditorFontCss(selectorPrefix) {
  return RICH_EDITOR_FONTS.map(function (font) {
    return (
      selectorPrefix +
      ' .ql-font-' +
      font.value +
      ' { font-family: ' +
      font.family +
      '; }'
    )
  }).join('\n')
}
